module.exports = __webpack_public_path__ + "media/images/home/plan/option_1-b631c203a262393b4ede35446cf28ef8.png";